export default "__VITE_ASSET__59c23e37__"